import React from "react";
import DetailClientsPoliciesLayout from "./detail-clients-policies-layout";

export default class DetailClientsPolicies extends React.Component<{}, {}> {
  render() {
    return <DetailClientsPoliciesLayout />;
  }
}
